import React from "react";

import * as Hi from "react-icons/hi";

type IconProps = {
  name: string;
  size?: string;
  color?: string;
};

export const Icon: React.FC<IconProps> = ({ name, size, color }) => {
  // @ts-ignore
  let iconComponent = React.createElement(Hi[name]);
  const iconSize =
    size === "xsmall"
      ? "0.65rem"
      : size === "small"
      ? "1rem"
      : size === "large"
      ? "2.5rem"
      : size === "xlarge"
      ? "3rem"
      : size === "xxlarge"
      ? "3.8rem"
      : "1.4rem";

  return (
    <div style={{ fontSize: iconSize, color: color, textAlign: "center" }}>
      {iconComponent}
    </div>
  );
};
